// extracted by mini-css-extract-plugin
export default {"TrafficNow":"_2n4kL7wLDR"};